export const environment = {
  production: true,
  
  apiUrl: "https://umyonightlife.com/api_umyocards/public/api/"
};


